import { UrlUtils } from "@lib-shared/lib";

const urlPrefix = "https://unificationdev.azurewebsites.net";

const prefixUrl = (url: string | undefined) => {
    if (!url) {
        return "";
    }

    if (window.location.hostname !== "localhost" || url.toLowerCase().startsWith("http")) {
        return url;
    }

    return UrlUtils.join(urlPrefix, url);
}

export default prefixUrl;